export default __webpack_public_path__ + "static/media/ST4_Grand_stretch.64cdb8cc.png";